import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard,
  Utils
} from 'viggo-sistemas-core-web';

export const routesAdminFiscal: Routes = [
  {
    path: 'nfes',
    loadChildren: () =>
      import('@modules/nfe/nfe.module').then(m => m.NfeModule),
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'NFE',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      breadcrumb: {
        label: 'NFe',
        icon: 'pi pi-fw pi-calculator'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'nfces',
    loadChildren: () =>
      import('@modules/nfce/nfce.module').then(m => m.NfceModule),
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'NFCE',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      breadcrumb: {
        label: 'NFCe',
        icon: 'pi pi-fw pi-calculator'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'entrada_fiscal',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'ENTRADA_FISCAL',
      breadcrumbMenu: Utils.getBreadcrumbMenu('SUPRIMENTOS'),
      preload: false,
      breadcrumb: {
        label: 'Entrada fiscal',
        icon: 'mdi mdi-xml'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/entrada-fiscal/entrada_fiscal.module').then(
        m => m.EntradaFiscalModule
      )
  },
  {
    path: 'regra_fiscal',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'REGRA_FISCAL',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Regra fiscal',
        icon: 'pi pi-fw pi-briefcase'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/regra-fiscal/regra_fiscal.module').then(
        m => m.RegraFiscalModule
      )
  },
  {
    path: 'natureza_operacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'NAT_OPERACAO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Natureza de operação',
        icon: 'pi pi-fw pi-key'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/natureza-operacao/naturezaoperacao.module').then(
        m => m.NaturezaOperacaoModule
      )
  },
  {
    path: 'serie_fiscal',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'SERIE_FISCAL',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Série fiscal',
        icon: 'mdi mdi-numeric'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/serie-fiscal/serie_fiscal.module').then(
        m => m.SerieFiscalModule
      )
  },
  {
    path: 'certificado_digital',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'CERTIFICADO_DIGITAL',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Certificado digital',
        icon: 'pi pi-fw pi-file'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import(
        '@app/modules/certificado-digital/certificado-digital.module'
      ).then(m => m.CertificadoDigitalModule)
  },
  {
    path: 'tipo_operacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'TIPO_OPERACAO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Tipo operação',
        icon: 'pi pi-fw pi-briefcase'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/tipo_operacao/tipo_operacao.module').then(
        m => m.TipoOperacaoModule
      )
  },
  {
    path: 'portaria',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PORTARIA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'Portaria',
        icon: 'pi pi-fw pi-wrench'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/portarias/portaria.module').then(
        m => m.PortariaModule
      )
  },
  {
    path: 'uficms',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'UFICMS',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','FISCAL'),
      preload: false,
      breadcrumb: {
        label: 'UFICMS',
        icon: 'pi pi-fw pi-calculator'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/uficms/uficms.module').then(m => m.UFICMSModule)
  },
  {
    path: 'ncm_ibpts',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'NCM_IBPT',
      preload: false,
      breadcrumb: {
        label: 'NCM IBPT',
        icon: 'pi pi-fw pi-file'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/ncm_ibpt/ncm_ibpt.module').then(m => m.NcmIbptModule)
  }
];
